// Aansluitingen: een club sluit zich aan bij een bond (fase 2 clubregister).
//
// Eén pagina, twee kanten. Een organisatie met de module bond ziet zijn
// aangesloten clubs en beslist over aanvragen. Een club ziet zijn eigen
// aansluitingen en kan er een aanvragen. Alles gaat via databasefuncties; de
// database beslist wie wat mag, dit scherm legt het voor en toont het.
import { getClient } from '../data/supabase.js';
import { state } from '../state.js';
import { heeft, heeftModule } from '../router.js';
import { t, locale } from '../lib/i18n.js';
import { esc } from '../lib/format.js';
import { toast } from '../ui/toast.js';
import { vraagReden } from '../ui/reden.js';

const sb = () => getClient();

const datum = iso => {
  if (!iso) return '';
  const d = new Date(iso.length > 10 ? iso : iso + 'T00:00:00Z');
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString(locale(), { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' });
};
const klein = tekst => `<p style="font-size:12px;color:var(--text-3)">${esc(tekst)}</p>`;
const knop = (actie, icoon, tekst, soort = 'btn-default', extra = '') =>
  `<button type="button" class="btn ${soort} btn-sm" data-aans="${actie}" ${extra}><i class="ti ti-${icoon}"></i> ${esc(tekst)}</button>`;
const BADGE = { aangevraagd: 'badge-amber', in_gesprek: 'badge-blue', actief: 'badge-green', beeindigd: 'badge-grey' };

export function aansluitFout(e) {
  const m = String(e?.message || e || '').match(/aansluiting:([a-z_]+)/);
  return m ? t('aans.fout.' + m[1]) : t('alg.fout', { melding: e?.message || String(e) });
}

// ── Goedkeuren: kies een registerclub of maak een nieuwe ───────────────────
function vraagKoppeling(rij, vrij) {
  return new Promise(klaar => {
    document.getElementById('aansModal')?.remove();
    const m = document.createElement('div');
    m.className = 'modal-overlay open';
    m.id = 'aansModal';
    m.innerHTML = `<div class="modal" style="max-width:520px">
      <div class="modal-header"><span class="modal-title">${esc(t('aans.goedkeuren.titel'))}</span>
        <button type="button" class="btn-icon" data-aans-m="annuleer" title="${esc(t('alg.sluiten'))}"><i class="ti ti-x"></i></button></div>
      <div class="modal-body">
        <p style="font-size:13px;color:var(--text-2);margin-bottom:12px">${esc(t('aans.goedkeuren.uitleg', { naam: rij.club_org_naam || rij.register_naam || '' }))}</p>
        <label class="eigendom-doc"><input type="radio" name="aansKeuze" value="" checked>
          <span><strong>${esc(t('aans.goedkeuren.nieuw', { naam: rij.club_org_naam || '' }))}</strong></span></label>
        ${vrij.length ? `<label class="eigendom-doc"><input type="radio" name="aansKeuze" value="bestaand">
          <span><strong>${esc(t('aans.goedkeuren.bestaand'))}</strong><br>
            <select class="form-input" name="aansRegister" style="margin-top:6px">${vrij.map(c => `<option value="${esc(c.id)}">${esc(c.naam)}${c.plaats ? ' (' + esc(c.plaats) + ')' : ''} &middot; ${esc(c.ref)}</option>`).join('')}</select></span></label>` : ''}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-aans-m="annuleer">${esc(t('alg.annuleren'))}</button>
        <button type="button" class="btn btn-primary" data-aans-m="ok">${esc(t('aans.knop.goedkeuren'))}</button>
      </div></div>`;
    document.body.appendChild(m);
    const sluit = uitkomst => { m.remove(); klaar(uitkomst); };
    m.addEventListener('click', e => {
      if (e.target === m || e.target.closest('[data-aans-m="annuleer"]')) return sluit(null);
      if (!e.target.closest('[data-aans-m="ok"]')) return;
      const keuze = m.querySelector('[name="aansKeuze"]:checked')?.value;
      sluit({ registerId: keuze === 'bestaand' ? m.querySelector('[name="aansRegister"]').value : null });
    });
  });
}

// ── Pagina ─────────────────────────────────────────────────────────────────
let rijen = [];

export async function render() {
  const el = document.getElementById('aansluitingenInhoud');
  if (!el) return;
  const org = state.currentOrgId;
  const alsBond = heeftModule('bond');
  el.innerHTML = '<div class="spinner"></div>';
  koppel(el, alsBond);

  const { data, error } = await sb().rpc('aansluitingen_lijst', { p_org: org });
  if (error) {
    el.innerHTML = `<div class="banner banner-amber"><i class="ti ti-alert-triangle"></i><span>${esc(t('aans.nietbeschikbaar'))}</span></div>`;
    return;
  }
  rijen = data || [];

  const regels = alsBond ? await bondData(org) : { register: [], bonden: [] };
  if (!alsBond && heeft('org.manage')) {
    const b = await sb().rpc('bonden_zoeken', { p_zoek: null });
    regels.bonden = b.error ? [] : (b.data || []);
  }
  el.innerHTML = alsBond ? bondHtml(regels) : clubHtml(regels);
}

async function bondData(org) {
  const { data, error } = await sb().from('club_register').select('id, ref, naam, plaats, claimed_org_id, status')
    .eq('organisation_id', org).eq('status', 'actief').order('naam');
  return { register: error ? [] : (data || []), bonden: [] };
}

const rijHtml = (r, alsBond, knoppen) => {
  const naam = alsBond ? (r.register_naam || r.club_org_naam || '') : r.bond_naam;
  const regel = [];
  if (r.status === 'beeindigd') regel.push(t('aans.tot', { datum: datum(r.ends_on), reden: r.reden_einde || '' }));
  else if (r.status === 'actief') regel.push(t('aans.sinds', { datum: datum(r.starts_on) }));
  else regel.push(t('aans.van', { door: r.aangevraagd_door || '-', datum: datum(r.aangevraagd_op) }));
  if (alsBond && r.register_ref) regel.push(r.register_ref);
  if (alsBond && r.club_org_naam && r.club_org_naam !== naam) regel.push(t('aans.organisatie', { naam: r.club_org_naam }));
  if (r.notitie) regel.push('“' + r.notitie + '”');
  return `<div class="org-row" style="align-items:flex-start">
    <div style="flex:1;min-width:220px">
      <div style="font-size:13px;font-weight:600">${esc(naam)}
        <span class="badge ${BADGE[r.status] || 'badge-grey'}">${esc(t('aans.status.' + r.status))}</span></div>
      <div style="font-size:11px;color:var(--text-3);margin-top:3px">${esc(regel.join(' · '))}</div>
    </div>${knoppen}</div>`;
};

function bondHtml({ register }) {
  const beheer = heeft('club.manage');
  const open = rijen.filter(r => r.status === 'aangevraagd' || r.status === 'in_gesprek');
  const actief = rijen.filter(r => r.status === 'actief');
  const einde = rijen.filter(r => r.status === 'beeindigd');
  const bezet = new Set(rijen.filter(r => r.status !== 'beeindigd').map(r => r.club_register_id));
  const toevoegbaar = register.filter(c => !bezet.has(c.id));

  const knopRij = r => !beheer ? '' : (r.status === 'aangevraagd' || r.status === 'in_gesprek')
    ? `<div style="display:flex;gap:6px;flex-wrap:wrap">
        ${r.status === 'aangevraagd' ? knop('ingesprek', 'messages', t('aans.knop.ingesprek'), 'btn-default', `data-id="${esc(r.id)}"`) : ''}
        ${knop('goedkeuren', 'check', t('aans.knop.goedkeuren'), 'btn-primary', `data-id="${esc(r.id)}"`)}
        ${knop('afwijzen', 'x', t('aans.knop.afwijzen'), 'btn-default', `data-id="${esc(r.id)}"`)}</div>`
    : r.status === 'actief' ? knop('beeindigen', 'unlink', t('aans.knop.beeindigen'), 'btn-ghost', `data-id="${esc(r.id)}"`) : '';

  return `
    <div class="settings-card breed">
      <h3>${esc(t('aans.titel.bond'))}</h3>
      <div class="settings-desc">${esc(t('aans.uitleg.bond'))}</div>
      ${open.length ? `<div class="section-title"><i class="ti ti-hourglass"></i> ${esc(t('aans.sectie.beoordelen'))}</div>
        ${open.map(r => rijHtml(r, true, knopRij(r))).join('')}` : ''}
      <div class="section-title" style="margin-top:12px"><i class="ti ti-link"></i> ${esc(t('aans.sectie.actief'))} (${actief.length})</div>
      ${actief.map(r => rijHtml(r, true, knopRij(r))).join('') || klein(t('aans.leeg'))}
      ${einde.length ? `<div class="section-title" style="margin-top:12px"><i class="ti ti-unlink"></i> ${esc(t('aans.sectie.beeindigd'))}</div>
        ${einde.map(r => rijHtml(r, true, '')).join('')}` : ''}
    </div>
    ${beheer ? `<div class="settings-card breed">
      <h3>${esc(t('aans.toevoegen.titel'))}</h3>
      <div class="settings-desc">${esc(t('aans.toevoegen.uitleg'))}</div>
      ${toevoegbaar.length ? `<div class="form-row" style="align-items:flex-end">
        <div class="form-group" style="flex:2"><label class="form-label">${esc(t('aans.toevoegen.club'))}</label>
          <select class="form-input" name="aans_club">${toevoegbaar.map(c => `<option value="${esc(c.id)}">${esc(c.naam)}${c.plaats ? ' (' + esc(c.plaats) + ')' : ''}</option>`).join('')}</select></div>
        <div class="form-group"><label class="form-label">${esc(t('aans.toevoegen.status'))}</label>
          <select class="form-input" name="aans_status"><option value="actief">${esc(t('aans.status.actief'))}</option>
            <option value="in_gesprek">${esc(t('aans.status.in_gesprek'))}</option></select></div>
        <div class="form-group" style="flex:2"><label class="form-label">${esc(t('aans.notitie'))}</label><input class="form-input" name="aans_notitie"></div>
        ${knop('toevoegen', 'plus', t('aans.knop.toevoegen'), 'btn-primary')}
      </div>` : klein(t('aans.toevoegen.geen'))}
      <div class="section-title" style="margin-top:14px"><i class="ti ti-building-community"></i> ${esc(t('aans.register.titel'))}</div>
      <div class="form-row" style="align-items:flex-end">
        <div class="form-group" style="flex:2"><label class="form-label">${esc(t('aans.register.naam'))}</label><input class="form-input" name="aans_naam"></div>
        <div class="form-group"><label class="form-label">${esc(t('aans.register.plaats'))}</label><input class="form-input" name="aans_plaats"></div>
        ${knop('register-toevoegen', 'plus', t('aans.knop.registerclub'), 'btn-default')}
      </div>
    </div>` : ''}`;
}

function clubHtml({ bonden }) {
  const kan = heeft('org.manage');
  const bezet = new Set(rijen.filter(r => r.status !== 'beeindigd').map(r => r.bond_id));
  const keuze = bonden.filter(b => !bezet.has(b.id));
  const knopRij = r => !kan ? '' : r.status === 'aangevraagd' ? knop('beeindigen', 'x', t('aans.knop.intrekken'), 'btn-ghost', `data-id="${esc(r.id)}"`)
    : (r.status === 'in_gesprek' || r.status === 'actief') ? knop('beeindigen', 'unlink', t('aans.knop.beeindigen'), 'btn-ghost', `data-id="${esc(r.id)}"`) : '';
  return `
    <div class="settings-card breed">
      <h3>${esc(t('aans.titel.club'))}</h3>
      <div class="settings-desc">${esc(t('aans.uitleg.club'))}</div>
      ${rijen.map(r => rijHtml(r, false, knopRij(r))).join('') || klein(t('aans.leeg'))}
    </div>
    ${kan ? `<div class="settings-card breed">
      <h3>${esc(t('aans.aanvragen.titel'))}</h3>
      ${keuze.length ? `<div class="form-row" style="align-items:flex-end">
        <div class="form-group" style="flex:2"><label class="form-label">${esc(t('aans.aanvragen.bond'))}</label>
          <select class="form-input" name="aans_bond">${keuze.map(b => `<option value="${esc(b.id)}">${esc(b.name)}</option>`).join('')}</select></div>
        <div class="form-group" style="flex:2"><label class="form-label">${esc(t('aans.notitie'))}</label><input class="form-input" name="aans_notitie"></div>
        ${knop('aanvragen', 'send', t('aans.knop.aanvragen'), 'btn-primary')}
      </div>` : klein(t('aans.aanvragen.geen'))}
    </div>` : ''}`;
}

// ── Handelingen ────────────────────────────────────────────────────────────
function koppel(el, alsBond) {
  el.onclick = async e => {
    const k = e.target.closest('[data-aans]');
    if (!k || k.disabled) return;
    const a = k.dataset.aans;
    const veld = naam => el.querySelector(`[name="${naam}"]`)?.value?.trim() || '';
    const id = k.dataset.id;
    const rij = rijen.find(r => r.id === id);
    const klaar = async melding => { if (melding) toast(melding, 'success'); await render(); };
    const rpc = async (naam, args, melding) => {
      const { error } = await sb().rpc(naam, args);
      if (error) { toast(aansluitFout(error), 'error'); return; }
      await klaar(melding);
    };

    if (a === 'aanvragen') {
      const bond = veld('aans_bond');
      if (!bond) return;
      return rpc('aansluiting_aanvragen', { p_club_org: state.currentOrgId, p_bond: bond, p_notitie: veld('aans_notitie') || null }, t('aans.aangevraagd'));
    }
    if (a === 'toevoegen') {
      const club = veld('aans_club');
      if (!club) return;
      return rpc('aansluiting_toevoegen', { p_bond: state.currentOrgId, p_register_id: club, p_status: veld('aans_status') || 'actief',
        p_start: null, p_notitie: veld('aans_notitie') || null }, t('leden.opgeslagen'));
    }
    if (a === 'register-toevoegen') {
      const naam = veld('aans_naam');
      if (!naam) return;
      const { error } = await sb().from('club_register').insert([{ organisation_id: state.currentOrgId, naam, plaats: veld('aans_plaats') || null }]);
      if (error) { toast(error.code === '23505' ? t('aans.fout.naam_bezet') : aansluitFout(error), 'error'); return; }
      return klaar(t('leden.opgeslagen'));
    }
    if (a === 'ingesprek') return rpc('aansluiting_in_gesprek', { p_id: id }, t('leden.opgeslagen'));
    if (a === 'goedkeuren' && rij) {
      // Een aanvraag van een bond zelf (geen club-organisatie) heeft al een registerclub.
      if (!rij.club_org_id) {
        return rpc('aansluiting_besluiten', { p_id: id, p_goedkeuren: true, p_register_id: null, p_reden: null }, t('aans.goedgekeurd'));
      }
      const { data } = await sb().from('club_register').select('id, ref, naam, plaats, claimed_org_id')
        .eq('organisation_id', state.currentOrgId).eq('status', 'actief').is('claimed_org_id', null).order('naam');
      const uit = await vraagKoppeling(rij, data || []);
      if (!uit) return;
      return rpc('aansluiting_besluiten', { p_id: id, p_goedkeuren: true, p_register_id: uit.registerId, p_reden: null }, t('aans.goedgekeurd'));
    }
    if (a === 'afwijzen') {
      const uit = await vraagReden({ titel: t('aans.afwijzen.titel'), uitleg: t('aans.afwijzen.uitleg'), knop: t('aans.knop.afwijzen'), gevaar: true, voorbeeld: t('aans.reden.voorbeeld') });
      if (!uit) return;
      return rpc('aansluiting_besluiten', { p_id: id, p_goedkeuren: false, p_register_id: null, p_reden: uit.reden }, t('aans.afgewezen'));
    }
    if (a === 'beeindigen') {
      const uit = await vraagReden({ titel: t('aans.beeindigen.titel'), uitleg: t(alsBond ? 'aans.beeindigen.uitleg.bond' : 'aans.beeindigen.uitleg.club'),
        knop: t('aans.knop.beeindigen'), gevaar: true, voorbeeld: t('aans.reden.voorbeeld') });
      if (!uit) return;
      return rpc('aansluiting_beeindigen', { p_id: id, p_datum: null, p_reden: uit.reden }, t('aans.beeindigd'));
    }
  };
}
